

import { formatCurrencyFull } from "@/lib/data";

interface QuotationFinancialSummaryProps {
  subtotal: number;
  discountType: 'fixed' | 'percentage';
  discountValue: number;
  tax: number;
  total: number;
}

export default function QuotationFinancialSummary({
  subtotal,
  discountType,
  discountValue,
  tax,
  total,
}: QuotationFinancialSummaryProps) {
  return (
    <div className="bg-white rounded-xl border border-stone-200 shadow-sm overflow-hidden">
      <div className="px-6 py-4 bg-gradient-to-r from-stone-50 to-white border-b border-stone-200">
        <h2 className="text-lg font-semibold text-stone-800">Financial Summary</h2>
      </div>
      <div className="p-6 space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-stone-700 mb-2">Subtotal</label>
            <div className="px-3 py-2 bg-stone-50 border border-stone-200 rounded-lg text-stone-800 font-semibold">
              {formatCurrencyFull(subtotal)}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-stone-700 mb-2">Discount Type</label>
            <div className="px-3 py-2 bg-stone-50 border border-stone-200 rounded-lg text-stone-800 capitalize">
              {discountType}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-stone-700 mb-2">Discount Value</label>
            <div className="px-3 py-2 bg-stone-50 border border-stone-200 rounded-lg text-stone-800">
              {discountType === 'percentage' ? `${discountValue}%` : formatCurrencyFull(discountValue)}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-stone-700 mb-2">Tax</label>
            <div className="px-3 py-2 bg-stone-50 border border-stone-200 rounded-lg text-stone-800">
              {formatCurrencyFull(tax)}
            </div>
          </div>
        </div>
        
        <div className="border-t border-stone-200 pt-4">
          <div className="flex justify-between items-center">
            <label className="text-lg font-medium text-stone-700">Total Amount</label>
            <div className="px-4 py-2 bg-amber-50 border border-amber-200 rounded-lg text-lg font-bold text-amber-700">
              {formatCurrencyFull(total)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
